import { IcoDownCircle } from '@module/svg/icons';

interface Props {
  onClick: () => void;
}

function ScrollDownButton({ onClick }: Props) {
  return (
    <button
      onClick={onClick}
      type='button'
      className='absolute bottom-[130px] left-[50%] z-20 translate-x-[-50%] text-colorIco44'
    >
      <IcoDownCircle style={{ fontSize: 36 }} />
    </button>
  );
}

export default ScrollDownButton;
